<template>
  <div class="hero">
    <span class="hero-text">LG GRAM
      <p v-html="title">
      </p>
    </span>
    <img v-if="windowWidth > 1024" src="/ru/lggramstore/images/desktop/hero/nout.png" alt="logo"/>
    <img v-else src="/ru/lggramstore/images/desktop/hero/nout728.png" alt="logo"/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: 'РЕЗУЛЬТАТЫ КОНКУРСА #openLGgram'
    }
  },
  computed:{
    windowWidth() {
      return window.innerWidth
    }
  }
}
</script>
<style lang="scss">
@import "hero";
</style>